import {
  Grid,
  IconButton,
  Tooltip
} from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { estadoColores, estadoIconos } from "src/projects/gestion_documental/components/estadosCajas";
import { useContext, useEffect, useState } from "react";
import { ListTablePaginated } from "src/general_components/ListTablePaginated";
import { LoadingOverlay } from "src/general_components/LoadingOverlay";
import { getCuentasLocalizaciones } from "src/projects/gestion_comercial/helpers/CuentasLocalizaciones";
import MostrarImagenTabla from "src/projects/gestion_documental/components/BuscadorDashboard/MostrarImagenTabla";
import ContenidosMetadatosCell from "src/projects/gestion_documental/components/BuscadorDashboard/TablaMetadatosContenidosDashboard";
import {
  getContenidos,
  getContenidosPaginatedDashboard,
} from "src/projects/gestion_documental/helpers/ContenidosData";
import BuscadorGeneral from "src/projects/gestion_documental/components/BuscadorDashboard/BuscadorGeneral";
import esArray from "src/general_components/functionEsArray";
import { CajasContext, CajasProvider } from "src/context/CajasContext/CajasContext";

export const DashboardDlys = () => (
  <CajasProvider>
    <DashboardDlysInner />
  </CajasProvider>
);

const DashboardDlysInner = () => {
  const { dataSearchFormGeneral, actualizarListado: cajasActualizarListado, setActualizarListado: setCajasActualizarListado } = useContext(CajasContext);

  const [searchQuery, setSearchQuery] = useState("");
  const [loadingImagenes, setLoadingImagenes] = useState(false);
  const [buscadorEjecutado, setBuscadorEjecutado] = useState(false);
  const [actualizarListado, setActualizarListado] = useState(false);
  const [idsCuentasLocalizaciones, setIdsCuentasLocalizaciones] = useState([]);
  const [clienteSeleccionado, setClienteSeleccionado] = useState(null);

  // Función para buscar los parametros del proyecto
  const clientData = JSON.parse(localStorage.getItem("clientData"))
  const imgUrl = clientData.dominio + '/static_content/img/' + clientData.owner_code + '_LOGO.JPG'

  useEffect(() => {

    const handleSearch = async () => {
      try {
        let idsLocalizaciones = idsCuentasLocalizaciones;
        let promises = false;
        let idsLocalizaciones_filtrados = idsCuentasLocalizaciones;
        if (!idsCuentasLocalizaciones || idsCuentasLocalizaciones.length === 0) {
          const user_cuentas = JSON.parse(
            localStorage.getItem("siam-user-cuentas")
          );
          const user_cuentas_localizaciones = JSON.parse(
            localStorage.getItem("siam-user-cuentas-localizaciones")
          );


          if (esArray(user_cuentas).length === 1) {

            promises = esArray(user_cuentas).map((idCuenta) =>
              getCuentasLocalizaciones(idCuenta.id_cuentas)
            );
          } else if (clienteSeleccionado) {

            promises = esArray(clienteSeleccionado).map((cliente) =>
              getCuentasLocalizaciones(cliente.id_cuentas)
            );


          }

          if (promises) {
            const results = await Promise.all(promises);
            idsLocalizaciones = results.flat().map((item) => item.id);
            idsLocalizaciones_filtrados = idsLocalizaciones;

            // Filtrar los objetos que tengan un id_cuentas_localizaciones presente en ids
            const filtrados = user_cuentas_localizaciones?.filter(obj => idsLocalizaciones.includes(obj.id_cuentas_localizaciones));


            if (user_cuentas_localizaciones && user_cuentas_localizaciones.length > 0) {
              const result = getCuentasLocalizacionesArray(filtrados);
              // Solo se setea si hay coincidencias en filtrados
              if (filtrados.length > 0) {
                idsLocalizaciones_filtrados = result;
                setIdsCuentasLocalizaciones(result);
              }
            } else {
              idsLocalizaciones_filtrados = idsLocalizaciones;
              setIdsCuentasLocalizaciones(idsLocalizaciones);
            }

          }

        }
        setOptions({
          ...options,
          sinFilas: false,
          idElementData: {
            idLocalizaciones: idsLocalizaciones_filtrados,
            inputSearch: searchQuery,
            busqueda_digitalizaciones: searchQuery.busqueda_digitalizaciones || false,
          },
        });
        setBuscadorEjecutado(true);
        setActualizarListado(false);
      } catch (error) {
        console.error("Error en la búsqueda:", error);
      } finally {

      }
    };

    actualizarListado && handleSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [buscadorEjecutado, searchQuery, actualizarListado]);

  // Escuchar actualizarListado del contexto (disparado por TotalizadoresSearch)
  useEffect(() => {
    if (cajasActualizarListado) {
      const customQuery = dataSearchFormGeneral?.search_params?.custom_query || {};
      setOptions(prev => ({
        ...prev,
        idElementData: prev.idElementData ? {
          ...prev.idElementData,
          custom_query: customQuery,
        } : prev.idElementData,
      }));
      setCajasActualizarListado(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cajasActualizarListado]);



  let columns = [
    {
      field: "clienteName",
      headerName: "Cliente",
      flex: 1.5,
      minWidth: 160,
      headerAlign: "center",
    },
    {
      field: "sector",
      headerName: "Sector",
      flex: 1.2,
      minWidth: 130,
      headerAlign: "center",
    },
    {
      field: "id_caja",
      headerName: "Caja",
      flex: 0.5,
      minWidth: 80,
      headerAlign: "center",
    },
    {
      field: "id_tipo_cajas",
      headerName: "Tipo Caja",
      flex: 0.6,
      minWidth: 90,
      headerAlign: "center",
    },
    {
      field: "referencia",
      headerName: "Nro Ant.",
      flex: 0.7,
      minWidth: 100,
      headerAlign: "center",
      renderCell: (params) => {
        const referencia = params.row.referencia;
        const esObjetoVacio = (ref) =>
          ref && typeof ref === "object" && Object.keys(ref).length === 0;
        return esObjetoVacio(referencia) || !referencia ? "-" : referencia;
      },
    },
    {
      field: "estados_cajas",
      headerName: "Estado",
      flex: 0.5,
      minWidth: 80,
      headerAlign: "center",
      renderCell: (params) => {
        if (params.value) {
          const color = estadoColores[params.value] || "defaultColor";
          const icono = estadoIconos[params.value] || <ErrorOutlineIcon />;
          return (
            <Grid style={{ alignItems: "center", textAlign: "center", margin: "auto" }}>
              <Tooltip title={params.value}>
                <IconButton style={{ color: color }}>
                  {icono}
                </IconButton>
              </Tooltip>
            </Grid>
          );
        }
        return null;
      },
    },
    {
      field: "lote",
      headerName: "Lote",
      minWidth: 70,
      headerAlign: "center",
      renderCell: (params) => {
        const cliente = params.row.cliente;
        const sector = params.row.sector;
        const value = params.row.lote;
        const id_caja = params.row.id_caja;
        const id_contenido = params.row.id;
        const descripcion_tipo_contenido = params.row.tipo_contenidos;
        const id_tipo_contenidosR = params.row.id_tipo_contenidos;
        return (
          <Tooltip
            title={
              <>
                <div>Cliente: {cliente}</div>
                <div>Sector: {sector}</div>
                <div>id caja: {id_caja}</div>
                <div>id contenido: {id_contenido}</div>
                <div>Tipo de Contenido: {id_tipo_contenidosR + " - " + descripcion_tipo_contenido}</div>
              </>
            }
          >
            <div>{value}</div>
          </Tooltip>
        );
      },
    },
    {
      field: "ubicacion",
      headerName: "Ubicación",
      flex: 1,
      minWidth: 150,
      headerAlign: "center",
      renderCell: (params) => {
        const val = params.value;
        if (!val || typeof val === "object") return "-";
        return val;
      },
    },
    {
      field: "id_contenidos",
      headerName: "Contenidos",
      flex: 3,
      minWidth: 320,
      headerAlign: "center",
      renderCell: (params) => {
        return <ContenidosMetadatosCell row={params.row} />;
      },
    },
    {
      field: "imagenes",
      headerName: "Imagen",
      flex: 0.5,
      minWidth: 80,
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <MostrarImagenTabla
            id_caja={params.row.id_caja}
            id_contenido={params.row.id}
            row={params.row.imagenes}
            setLoading={setLoadingImagenes}
          />
        );
      },
    },
  ];

  let columnsExports = ['ID caja', 'Cliente', 'Sector', 'Referencia/Nro Anterior', 'Tipo de caja(id)', 'Lote', 'Tipo de contenido', 'Metadatos']
  const [options, setOptions] = useState({
    cols: columns,
    get: getContenidos,
    getPaginated: getContenidosPaginatedDashboard,
    pageSize: [5, 10, 25],
    limit: 50,
    filter: true,
    exportData: true,
    server: true,
    sinFilas: true,
    paginar: "true",
    exportarCajasContenidos: true,
    exportarCajasContenidosColumns: columnsExports,
    totales: true,
  });

  const getCuentasLocalizacionesArray = (data) => {
    return data.map(item => item.id_cuentas_localizaciones);
  };

  return (
    <div>
      {/* Se creo un componente aparte para el tema de la busqueda, asi no se produce delay/demora al escribir */}
      <BuscadorGeneral
        setSearchQuery={setSearchQuery}
        setBuscadorEjecutado={setBuscadorEjecutado}
        clienteSeleccionado={clienteSeleccionado}
        setClienteSeleccionado={setClienteSeleccionado}
        setOptions={setOptions}
        options={options}
        setIdsCuentasLocalizaciones={setIdsCuentasLocalizaciones}
        setActualizarListado={setActualizarListado} />

      {buscadorEjecutado ? (
        <div style={{ marginTop: "20px", overflowX: "auto" }}>
          <ListTablePaginated options={options} />
        </div>
      ) : (
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          style={{ height: "70vh" }}
        >
          <Grid item xs={12} style={{ textAlign: "center" }}>
            <img
              src={imgUrl}
              alt="Bienvenido"
              style={{ maxWidth: "20%", height: "auto", marginBottom: 20 }}
            />

          </Grid>
        </Grid>
      )}
      <LoadingOverlay open={loadingImagenes} />
    </div>
  );
}
